import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { SignatureInputCssCarmiData, SignatureInputDefinition } from '@wix/thunderbolt-components-native'
import { withCompInfo } from '@wix/editor-elements-integrations'

export const css = withCompInfo<SignatureInputCssCarmiData, SignatureInputDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compLayout', 'styleProperties', 'siteFonts', 'isMobileView', 'compProps', 'isOneDocMigrated'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compLayout, styleProperties, siteFonts, isMobileView, compProps, isOneDocMigrated }) => {
		const compInfo = { compLayout, styleProperties, siteFonts, isMobileView, compProps }
		return {
			'--titleFont': getScaledFont(compInfo, 'titleFont', isOneDocMigrated, compProps.labelMobileFontSize),
			'--clearButtonFont': getScaledFont(
				compInfo,
				'clearButtonFont',
				isOneDocMigrated,
				compProps.inputMobileFontSize
			),
		}
	}
)
